import { useEffect, useState } from 'react'

import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useBlocker, useNavigate } from '@tanstack/react-router'

import type { TProfileResponse } from '@/api/auth/types'

import { api } from '@/api'

import DialogChangePassword from './DialogChangePassword'

const PROFILE_STORAGE_KEY = '__app-profile-data'

export default function FirstLoginPasswordGate() {
  const queryClient = useQueryClient()
  const navigate = useNavigate()
  const { data: profile } = useQuery(api.auth.getProfile())
  const mustChange = Boolean(profile && !profile.password_changed_at)
  const [finished, setFinished] = useState(false)

  useBlocker({
    shouldBlockFn: ({ current, next }) =>
      mustChange && current.pathname !== next.pathname,
    enableBeforeUnload: false,
    disabled: !mustChange
  })

  useEffect(() => {
    if (!finished || mustChange) return
    navigate({ to: '/dashboard' })
  }, [finished, mustChange, navigate])

  if (!profile || !mustChange) return null

  return (
    <DialogChangePassword
      open
      profile={profile}
      onCompleted={(email, passwordChangedAt) => {
        const nextProfile: TProfileResponse = {
          ...profile,
          email,
          password_changed_at: passwordChangedAt
        }
        queryClient.setQueryData(api.auth.getProfile().queryKey, nextProfile)
        localStorage.setItem(PROFILE_STORAGE_KEY, JSON.stringify(nextProfile))
        setFinished(true)
      }}
    />
  )
}
